import React from "react";
import { ProductsSection } from "./ProductsSection";

interface BestSellersSectionProps {
  bestSellers: any[];
  allBestSellers: any[];
  isLoading?: boolean;
}

/**
 * Section "Nos Best Sellers" - Utilise ProductsSection pour un design identique
 */
export const BestSellersSection: React.FC<BestSellersSectionProps> = ({
  bestSellers,
  allBestSellers,
  isLoading = false,
}) => {
  return (
    <ProductsSection
      title="Nos best sellers"
      products={bestSellers}
      isLoading={isLoading}
      showViewMore={allBestSellers.length > 4}
      viewMoreText="Voir plus"
      viewMoreLink="/produits"
    />
  );
};
